function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) { ; } } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState } from "react";
import classNames from "classnames";
var classPrefix = "tc-index-bar";
export var Sidebar = function Sidebar(props) {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    interacting = _useState2[0],
    setInteracting = _useState2[1];
  return /*#__PURE__*/React.createElement("div", {
    className: classNames("".concat(classPrefix, "-sidebar"), _defineProperty({}, "".concat(classPrefix, "-sidebar-interacting"), interacting)),
    onMouseDown: function onMouseDown() {
      setInteracting(true);
    },
    onMouseUp: function onMouseUp() {
      setInteracting(false);
    },
    onTouchStart: function onTouchStart() {
      setInteracting(true);
    },
    onTouchEnd: function onTouchEnd() {
      setInteracting(false);
    },
    onTouchMove: function onTouchMove(e) {
      if (!interacting) return;
      var _e$touches$ = e.touches[0],
        clientX = _e$touches$.clientX,
        clientY = _e$touches$.clientY;
      var target = document.elementFromPoint(clientX, clientY);
      if (!target) return;
      var index = target.dataset.index;
      if (index) {
        props.onActive(index);
      }
    }
  }, props.indexItems.map(function (_ref) {
    var index = _ref.index,
      brief = _ref.brief;
    var active = index === props.activeIndex;
    return /*#__PURE__*/React.createElement("div", {
      className: "".concat(classPrefix, "-sidebar-row"),
      onMouseDown: function onMouseDown() {
        props.onActive(index);
      },
      onTouchStart: function onTouchStart() {
        props.onActive(index);
      },
      onMouseEnter: function onMouseEnter() {
        if (interacting) {
          props.onActive(index);
        }
      },
      "data-index": index,
      key: index
    }, interacting && active && /*#__PURE__*/React.createElement("div", {
      className: "".concat(classPrefix, "-sidebar-bubble")
    }, brief), /*#__PURE__*/React.createElement("div", {
      className: classNames("".concat(classPrefix, "-sidebar-item"), _defineProperty({}, "".concat(classPrefix, "-sidebar-item-active"), active)),
      "data-index": index
    }, /*#__PURE__*/React.createElement("div", null, brief)));
  }));
};